export interface AuthConfig {
  apiToken: string;
}

declare global {
  interface Window {
    __STUDIO_CONFIG__?: AuthConfig;
  }
}

export function getToken(): string {
  const runtime = typeof window !== "undefined" ? window.__STUDIO_CONFIG__?.apiToken : undefined;
  if (runtime && runtime.length > 0) return runtime;
  const envToken = import.meta.env.VITE_STUDIO_API_TOKEN;
  if (envToken && envToken.length > 0) return envToken;
  throw new Error(
    "No Studio API token configured. Set VITE_STUDIO_API_TOKEN or window.__STUDIO_CONFIG__.apiToken",
  );
}

export function getApiBase(): string {
  const base = import.meta.env.VITE_STUDIO_API_BASE;
  if (base && base.length > 0) return base;
  return "/api";
}
